/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import { SocialMedia, SocialMediaComponent } from '@msdyn365-commerce/components';
import MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ISocialShareItemConfig, ISocialShareItemProps, socialMedia } from './social-share-item.props.autogenerated';

export interface ISocialShareItemViewProps extends ISocialShareItemProps<ISocialShareItemConfig> {
    SocialShareItemElement: React.ReactNode | null;
    SocialShareItem: IModuleProps;
}

/**
 *
 * SocialShareItem component
 * @extends {React.PureComponent<ISocialShareItemProps<ISocialShareItemConfig>>}
 */
class SocialShareItem extends React.PureComponent<ISocialShareItemProps<ISocialShareItemConfig>> {
    constructor(props: ISocialShareItemProps<ISocialShareItemConfig>) {
        super(props);

        this._getSocialShareItem = this._getSocialShareItem.bind(this);
    }

    public render(): JSX.Element | null {
        const viewprops = {
            ...this.props,
            SocialShareItem: {
                moduleProps: this.props,
                className: 'ms-social-share-item'
            },
            SocialShareItemElement: this._getSocialShareItem()
        };

        return this.props.renderView(viewprops) as React.ReactElement;
    }

    private _getSocialShareItem(): React.ReactNode | null {
        const src = this.props.config.icon;
        if (MsDyn365.isBrowser) {
            switch (this.props.config.socialMedia) {
                case socialMedia.facebook:
                    return <SocialMediaComponent socialMedia={SocialMedia.Facebook} postUrl={document.URL} context={this.context} id={`${this.props.id}_facebook`} typeName={this.props.typeName} data={{}} src={src} />;
                case socialMedia.twitter:
                    return <SocialMediaComponent socialMedia={SocialMedia.Twitter} postUrl={document.URL} context={this.context} id={`${this.props.id}_twitter`} typeName={this.props.typeName} data={{}} src={src} />;
                case socialMedia.pinterest:
                    return <SocialMediaComponent socialMedia={SocialMedia.Pinterest} postUrl={document.URL} context={this.context} id={`${this.props.id}_pinterest`} typeName={this.props.typeName} data={{}} src={src} />;
                case socialMedia.linkedin:
                    return <SocialMediaComponent socialMedia={SocialMedia.Linkedin} postUrl={document.URL} context={this.context} id={`${this.props.id}_linkedin`} typeName={this.props.typeName} data={{}} src={src} />;
                case socialMedia.mail:
                    return <SocialMediaComponent socialMedia={SocialMedia.Mail} postUrl={document.URL} context={this.context} id={`${this.props.id}_mail`} typeName={this.props.typeName} data={{}} src={src} />;
                default:
                    return null;
            }
        }
        return null;
    }
}

export default SocialShareItem;
